<mf-page title="Nueva orden de cobro">
  @if (collectOrderDto) {
  <mf-collect-order
    [collectOrderDto]="collectOrderDto"
    (close)="close()"
    (save)="save($event)" />
  }
</mf-page>
